import { IQuery, IQueryMediator } from 'core-ts-types';
import * as _4 from 'lodash4';
import { IRegistrationActivityDatasource } from '../datasources/registration_activity_datasource';
import { RegistrationReceiptServant } from '../../course_scheduler/servants/registration_receipt_servant';

interface ITransactionRecord {
  id: number;
  title: string;
  message: string;
  success: boolean;
  action: string;
  transactionId: number;
  transactionDate: string;
}
interface IRegistrationTransactionsQueryResult {
  hasTransactions: boolean;
  transactions: ITransactionRecord[][];
}
export class RegistrationTransactionsQuery implements IQuery {
  private _result: IRegistrationTransactionsQueryResult = {
    hasTransactions: false,
    transactions: []
  };
  constructor(
    private QueryMediator: IQueryMediator,
    private ngRegistrationActivityDatasource: IRegistrationActivityDatasource,
    private ngRegistrationReceiptServant: RegistrationReceiptServant
  ) {
    this._result = {
      hasTransactions: false,
      transactions: []
    };
    QueryMediator.registerQuery(this, ngRegistrationActivityDatasource);
  }

  run() {
    const transactionData = this.ngRegistrationReceiptServant.getReceiptData();
    const hasTransactions = _4.gt(_4.size(transactionData), 0);
    const transactionsWithTimeStamp = _4.orderBy(
      _4.map(transactionData, (transaction) => {
        return { ...transaction, timeStamp: moment(transaction.transactionDate, 'MMM DD, YYYY h:m A').valueOf() };
      }),
      ['transactionId'],
      'desc'
    );
    const transactions = _4.reverse(_4.values(_4.groupBy(transactionsWithTimeStamp, 'transactionId')));
    this._result = { hasTransactions, transactions };
    return this;
  }

  get result() {
    return this._result;
  }
}

angular.module('capability-ng-scheduler').service('ngRegistrationTransactionsQuery', RegistrationTransactionsQuery);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/registration_transactions/queries/registration_transactions_query.ts